import { useState } from "react"
import { useSelector } from "react-redux";
import AsyncSelect from 'react-select/async';

import debounce from 'lodash.debounce';
import { toast } from "react-toastify";
import { searchExams } from "../ExamApi";
import { selectTranslations } from "../../../services/i18n/i18nSlice";

export default function SearchExamInput(props) {

    const [showInput, setShowInput] = useState(false)
    const [selectedExam, setSelectedExam] = useState(null)
    const t = useSelector(selectTranslations)

    const _loadOptions =  (pattern, callback) => {
        console.log('call');
        searchExams({
            ...props?.filters || null,
            search_pattern: pattern
        }).then((r) => 
            callback(r.data?.exams)
        ).catch((e)=>
            toast.error(t.error.error_loading)
        )   
    }

    const loadOptions = debounce(_loadOptions,300)

    const handleSelectExam = () => {
        props.onSelectExam(selectedExam)
    }
    
    return(
            <div className="add_user_input" open={showInput}> 
                {showInput ?
                    <AsyncSelect 
                        loadOptions={loadOptions} 
                        hidden={!showInput}
                        getOptionLabel={u => ` ${u.title} `}
                        getOptionValue={u => u.exam_id}
                        className="addUserSelect"
                        classNamePrefix="addUserSelect"
                        onChange={setSelectedExam}
                    /> : "" }   
                {showInput ? 
                    <button onClick={handleSelectExam} disabled={!selectedExam}>
                        Seleziona Prova di verifica
                    </button>
                :
                    <button onClick={()=>{setShowInput(!showInput)}}>
                        Cerca Prova di verifica
                    </button>
                }
                
            </div>
    )

}